var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2481_4565)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8976 4.65001C8.83827 4.65001 5.54756 7.94071 5.54756 12C5.54756 16.0593 8.83827 19.35 12.8976 19.35C16.9569 19.35 20.2476 16.0593 20.2476 12C20.2476 7.94071 16.9569 4.65001 12.8976 4.65001ZM4.24756 12C4.24756 7.22274 8.12029 3.35001 12.8976 3.35001C17.6748 3.35001 21.5476 7.22274 21.5476 12C21.5476 16.7773 17.6748 20.65 12.8976 20.65C8.12029 20.65 4.24756 16.7773 4.24756 12ZM10.4379 10.3404L12.4379 8.34044C12.6918 8.0866 13.1033 8.0866 13.3572 8.34044L15.3572 10.3404C15.611 10.5943 15.611 11.0058 15.3572 11.2597C15.1033 11.5135 14.6918 11.5135 14.4379 11.2597L13.5476 10.3693V15.2001C13.5476 15.559 13.2565 15.8501 12.8976 15.8501C12.5386 15.8501 12.2476 15.559 12.2476 15.2001V10.3693L11.3572 11.2597C11.1033 11.5135 10.6918 11.5135 10.4379 11.2597C10.1841 11.0058 10.1841 10.5943 10.4379 10.3404Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2481_4565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.897461)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.66bb1e0c.svg";
export { ForwardRef as ReactComponent };